var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { color, font, space, border } from '../theme/helper';
export var ButtonStyles = function (props) {
    var lighterBrand = color('brand', 'lighter')(props);
    var normalBrand = color('brand', 'normal')(props);
    var darkerBrand = color('brand', 'darker')(props);
    return (props.styled &&
        "\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n\n    padding: " + space(2)(props) + ";\n\n    font-weight: bold;\n\n    " + font(3)(props) + ";\n\n    color: white;\n\n    background-color: " + normalBrand + ";\n\n    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n    border-radius: " + (props.theme.isHome24 ? '3px' : 0) + ";\n\n    cursor: pointer;\n    outline: none;\n\n    &:hover,\n    &:focus {\n      color: white;\n      background-color: " + lighterBrand + ";\n    }\n\n    &:active {\n      color: white;\n      background-color: " + darkerBrand + ";\n    }\n  ");
};
export var SecondaryButtonStyles = function (_a) {
    var fontSize = _a.fontSize, lineHeight = _a.lineHeight, props = __rest(_a, ["fontSize", "lineHeight"]);
    var normalBrand = color('brand', 'normal')(props);
    return "\n    text-align: center;\n\n    " + font(fontSize || 3, lineHeight)(props) + ";\n\n    border: " + border(1)(props) + ";\n    color: " + color('text')(props) + ";\n    padding: " + space(2)(props) + " " + space(3)(props) + ";\n\n    cursor: pointer;\n    font-weight: bold;\n    border-radius: " + (props.theme.isHome24 ? '3px' : 0) + ";\n    background-color: white;\n\n    &:hover,\n    &:focus {\n      border: " + border(2)(props) + ";\n    }\n\n    &:active {\n      border: 1px solid " + normalBrand + ";\n      color: " + normalBrand + ";\n    }\n  ";
};
export var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n\n  ", ";\n"], ["\n  display: inline-flex;\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n\n  ", ";\n"])), ButtonStyles);
Button.propTypes = {
    /** Button type. Available values: button, submit, reset */
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    /** Should the button render with all styles or with reset styles only (default: true) */
    styled: PropTypes.bool,
};
Button.defaultProps = {
    type: 'button',
    styled: true,
};
var templateObject_1;
